define('appquery',["jquery"], function($) {
    return function(app) {
        function appSelector(selector, context) {
            var App = $('#' + app);
            context = selector ? context || App : document;
            selector = selector || App;
            return $(selector, context);
        }
        appSelector.self = function() {
            return $('#' + app);
        };
        return appSelector;
    };
});
